import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { ncFileDetailsBatchConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const NCFileDetailsBatchStack = createStackNavigator();

const NCFileDetailsBatchNavigator = () => {
  return (
    <NCFileDetailsBatchStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFileDetailsBatchConfig.map(({ Component, name }) => (
        <NCFileDetailsBatchStack.Screen key={name} name={name} component={Component} />
      ))}
    </NCFileDetailsBatchStack.Navigator>
  );
};

export { NCFileDetailsBatchNavigator };
